import type { BaseModelAttributes } from "./base";
import { Locale } from "./locale";
import { I18nLabels } from "./common";

export enum UserRole {
  ADMIN = "admin",
  USER = "user",
}

export const UserRoleLabels: I18nLabels<UserRole> = {
  [UserRole.ADMIN]: { [Locale.ZH_CN]: "管理员", [Locale.EN_US]: "Admin" },
  [UserRole.USER]: { [Locale.ZH_CN]: "用户", [Locale.EN_US]: "User" },
};

export interface IUser extends BaseModelAttributes {
  username: string;
  email: string;
  password: string;
  name: string;
  role: UserRole;
}

export interface UpdateProfileRequest {
  name: string;
  email: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

// 认证相关类型
export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  name: string;
}

export interface AuthResponse {
  token: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
  };
}

export interface JwtPayload {
  userId: string;
  email: string;
  role: string;
  iat?: number;
  exp?: number;
}

// 用户响应类型（不包含敏感信息）
export interface UserResponse {
  id: string;
  username: string;
  email: string;
  name: string;
  role: UserRole;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  createdBy: string | null;
  updatedBy: string | null;
}
